const DEVICE_ID_KEY = 'DEVICE_ID_KEY';
import ClientApp from '@/client/index';
export const getDeviceId = () => {
  return window.localStorage.getItem(DEVICE_ID_KEY) || null;
};

export const setDeviceId = deviceId => {
  return window.localStorage.setItem(DEVICE_ID_KEY, deviceId || '');
};

export const saveDeviceAsync = async () => {
  const deviceId = getDeviceId();

  if (!deviceId) {
    ClientApp.getDeviceId().then(res => {
      if (res.deviceId) {
        setDeviceId(res.deviceId);
      }
    });
  }
};
